import {
  isCaseWorkspaceOperationsApi,
  resolveOperationsSource,
} from "./mehrsanOperationsConstants";

/** هم‌تراز با LoanProcessType در API */
export const LOAN_PROCESS_TYPE_APPLICATION = 1;

export const LOAN_STATUS_APPROVED = 5;
export const LOAN_STATUS_PAID = 7;
export const LOAN_STATUS_REJECTED = 6;
export const LOAN_STATUS_CANCELLED = 9;

export const LOAN_PROCESS_TYPES = [
  { value: 1, label: "درخواست وام" },
  { value: 2, label: "ارزیابی اعتباری" },
  { value: 3, label: "ارائه مدارک" },
  { value: 4, label: "تأیید وام" },
  { value: 5, label: "پرداخت وام" },
  { value: 6, label: "تسویه" },
  { value: 99, label: "سایر" },
];

/** هم‌تراز با LoanProcessStatus در API */
export const LOAN_PROCESS_STATUSES = [
  { value: 0, label: "پیش‌نویس" },
  { value: 1, label: "در حال پیگیری" },
  { value: 2, label: "در انتظار مدارک مشترک" },
  { value: 3, label: "در انتظار لندتک" },
  { value: 4, label: "نیاز به اصلاح" },
  { value: 5, label: "تأیید شده" },
  { value: 6, label: "رد شده" },
  { value: 7, label: "پرداخت شده" },
  { value: 8, label: "تسویه شده" },
  { value: 9, label: "لغو شده" },
  { value: 99, label: "سایر" },
];

/** وضعیت‌های میانی برای بروزرسانی روزانه (بدون اتمام/واریز) */
export const LOAN_FOLLOW_UP_STATUSES = LOAN_PROCESS_STATUSES.filter(
  (s) =>
    ![
      LOAN_STATUS_APPROVED,
      LOAN_STATUS_REJECTED,
      LOAN_STATUS_PAID,
      8,
      LOAN_STATUS_CANCELLED,
    ].includes(s.value)
);

export { resolveOperationsSource };

export const shouldShowLendingTab = isCaseWorkspaceOperationsApi;

export const getLoanStatusChipColor = (status) => {
  const s = Number(status);
  if (Number.isNaN(s)) return "default";
  if (s === 5 || s === 7 || s === 8) return "success";
  if (s === 6 || s === 9) return "error";
  if (s === 2 || s === 3 || s === 4) return "warning";
  return "default";
};
